import { FC, useMemo } from 'react';
import LazyLoad from 'react-lazyload';

import { addTransformToCloudinaryUrl, getOptimizedCloudinaryUrl } from 'utils/url';
import Avatar from '@z-components/atoms/Avatar';

const AVATAR_DIMENSION = 96;
const LAZY_LOAD_OFFSET = 200;

interface Props {
  avatar?: string;
  height?: number;
  name?: string;
  shouldTransform?: boolean;
  width?: number;
}

const ProfileAvatar: FC<Props> = ({
  avatar,
  height = AVATAR_DIMENSION,
  name,
  shouldTransform = true,
}) => {
  const src = useMemo(
    () =>
      shouldTransform && avatar
        ? getOptimizedCloudinaryUrl(
            addTransformToCloudinaryUrl(avatar, {
              rounded: true,
              width: height.toString(),
            })
          )
        : avatar,
    [avatar, height, shouldTransform]
  );

  return (
    <LazyLoad height={height} once={true} offset={LAZY_LOAD_OFFSET}>
      <Avatar alt={name} avatar={src} />
    </LazyLoad>
  );
};

export type { Props as ProfileAvatarProps };
export default ProfileAvatar;
